export const constraints = {
  email: {
    presence: { message: 'is required' },
    email   : { message: '^Invalid email' },
  },
  password: {
    presence: { message: 'is required' },
    length  : {
      minimum: 6,
      message: 'must be at least 6 characters',
    },
  },
};

export default constraints;
